import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useContext, useEffect, useState } from 'react';
import { Alert, Badge, Button, Col, Container, FloatingLabel, Form, Image, Row, Table } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import { LinkContainer } from 'react-router-bootstrap';
import { useLocation, useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import ApiFetch from './ApiFetch';
import CampaignMessage from './CampaignMessage';
import Category from './Category';
import Dialog from './Dialog';
import FavoriteIcon from './FavoriteIcon';
import Footer from './Footer';
import Header from './Header';
import { useTranslation } from "react-i18next";
import { Bar, Line } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';

// Chart.jsの必要な要素を登録
ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);
import { LoginInfo } from '../App';
import { Chip } from '@mui/material';
import GradientBlurText from './common/GradientBlurText';

const Analyze = () => {
    function createGraphData(r,title){
        const graphData = {
            labels: 
                // 軸ラベル
                // 各ラベルを配列にすることで軸ラベルが改行されて表示される
                r.map(d => [d.ymd])
            ,
            datasets: [
                // 表示するデータセット
                {
                    data: r.map(d => d.count),
                    label: title,
                    backgroundColor: title.includes('閲覧') ? 'rgba(85,170,255,0.3)' : 'rgba(255,99,132,0.3)',
                    borderColor: title.includes('閲覧') ? '#55AAFF' : '#FF6384',
                    borderWidth: 2,
                    fill: true,
                    tension: 0.4,
                    pointBackgroundColor: title.includes('閲覧') ? '#55AAFF' : '#FF6384',
                    pointBorderColor: '#fff',
                    pointBorderWidth: 2,
                    pointRadius: 4,
                    pointHoverRadius: 6,
                },
            ],
        }
        return graphData
    }
    function getPVByDay(userId, period = 30){
        const url = `${ApiFetch.API_PROTOCOL}//${ApiFetch.API_HOST}/v1/image/pv/${userId}?period=${period}`;
        return new ApiFetch().get(url).then((r)=>{
            return r.json()
        })
    }
    function getFavoriteCountByDay(userId, period = 30){
        const url = `${ApiFetch.API_PROTOCOL}//${ApiFetch.API_HOST}/v1/favorite/countByDay/${userId}?period=${period}`;
        return new ApiFetch().get(url).then((r)=>{
            return r.json()
        })
    }
    function getInvestList(){
        return new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/invest/list").then((r)=>{
            return r.json()
        })
    }
    function buy(stockCode,count){
        return new ApiFetch().put(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/invest/buy",{stockCode:stockCode,count:count}).then((r)=>{
            return r.json()
        })
    }
    function sell(stockCode,count){
        return new ApiFetch().put(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/invest/sell",{stockCode:stockCode,count:count}).then((r)=>{
            return r.json()
        })
    }
    function getPoint(){
        return new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/point").then((r)=>{
            return r.json()
        })
    }
    // ダイアログ
    const [show, setShow] = useState(false)
    const [dialogTitle, setDialogTitle] = useState("")
    const [dialogMessage, setDialogMessage] = useState("")
    const [okButtonShow,setOkButtonShow] = useState(false)
    function dialog(title,message){
        setDialogTitle(title)
        setDialogMessage(message)
        setShow(true)
    }

    const {t,i18n} = useTranslation()
    // ログイン情報
    const {loginInfo,setLoginInfo} = useContext(LoginInfo)

    const location = useLocation()
    const [registrationList,setRegistrationList] = useState()
    const [favoriteList,setFavoriteList] = useState()
    const [currentValue,setCurrentValue] = useState(0)
    const [yesterdayValue,setYesterdayValue] = useState(0)
    const [hikaku,setHikaku] = useState(0)
    const [investList,setInvestList] = useState([])
    const [count,setCount] = useState(0)
    const [pointOrPrice,setPointOrPrice] = useState(0)
    const [point,setPoint] = useState(0)
    const [marketCap,setMarketCap] = useState(0)
    const params = useParams()
    const userId = params.user_id || ""

    // ユーザー分析データ取得
    function getUserAnalyzeData(userId, period = 30) {
        const url = `${ApiFetch.API_PROTOCOL}//${ApiFetch.API_HOST}/v1/favorite/analyze/${userId}?period=${period}`;
        return new ApiFetch().get(url).then((r)=>r.json())
    }
    const [analyzeData, setAnalyzeData] = useState(null)
    const [period, setPeriod] = useState(30) // 期間状態を追加
    const [loading, setLoading] = useState(false) // ローディング状態を追加
    
    // 期間の表示形式を取得する関数
    const getPeriodLabel = (days) => {
        if (days === 7) return '過去7日'
        if (days === 30) return '過去30日'
        if (days === 90) return '過去90日'
        if (days === 180) return '過去180日'
        if (days === 365) return '過去1年'
        return `過去${days}日`
    }
    
    // 期間変更時のデータ再取得
    const handlePeriodChange = (newPeriod) => {
        setPeriod(newPeriod)
        setLoading(true)
        
        // ユーザー分析データの取得
        getUserAnalyzeData(loginInfo.userId, newPeriod).then(r => {
            if(r.result){
                setAnalyzeData(r.data)
            }
        }).finally(() => {
            setLoading(false)
        })
        
        // 日別推移データの取得
        getPVByDay(loginInfo.userId, newPeriod).then(r => {
            if(r.result){
                setRegistrationList(
                    <Line 
                        data={createGraphData(r.data.list,"日別閲覧数推移")} 
                        options={{
                            responsive: true,
                            maintainAspectRatio: false,
                            plugins: {
                                legend: {
                                    position: 'top',
                                },
                                title: {
                                    display: false,
                                },
                            },
                            scales: {
                                y: {
                                    beginAtZero: true,
                                },
                            },
                        }}
                    />
                )
            }
        })
        
        getFavoriteCountByDay(loginInfo.userId, newPeriod).then(r => {
            if(r.result){
                setFavoriteList(
                    <Line 
                        data={createGraphData(r.data.list,"日別いいね数推移")} 
                        options={{
                            responsive: true,
                            maintainAspectRatio: false,
                            plugins: {
                                legend: {
                                    position: 'top',
                                },
                                title: {
                                    display: false,
                                },
                            },
                            scales: {
                                y: {
                                    beginAtZero: true,
                                },
                            },
                        }}
                    />
                )
            }
        })
    }
    
    useEffect(() => {
        setLoading(true)
        if(!loginInfo.userId) {
            setLoading(false)
            return
        }
        getUserAnalyzeData(loginInfo.userId, period).then(r => {
            if(r.result){
                setAnalyzeData(r.data)
            }
        }).finally(() => {
            setLoading(false)
        })
    }, [loginInfo.userId])

	useEffect(() => {
        if(!loginInfo.userId) {
            setLoading(false)
            return
        }
		document.querySelector("title").textContent = t("common.analyze") + " - アワートAI"
        getPVByDay(userId || loginInfo.userId, period).then(r => {
            if(r.result){
                setRegistrationList(
                    <Line 
                        data={createGraphData(r.data.list,"日別閲覧数推移")} 
                        options={{
                            responsive: true,
                            maintainAspectRatio: false,
                            plugins: {
                                legend: {
                                    position: 'top',
                                },
                                title: {
                                    display: false,
                                },
                            },
                            scales: {
                                y: {
                                    beginAtZero: true,
                                },
                            },
                        }}
                    />
                )
            }
        })
        getFavoriteCountByDay(userId || loginInfo.userId, period).then(r => {
            if(r.result){
                setFavoriteList(
                    <Line 
                        data={createGraphData(r.data.list,"日別いいね数推移")} 
                        options={{
                            responsive: true,
                            maintainAspectRatio: false,
                            plugins: {
                                legend: {
                                    position: 'top',
                                },
                                title: {
                                    display: false,
                                },
                            },
                            scales: {
                                y: {
                                    beginAtZero: true,
                                },
                            },
                        }}
                    />
                )
            }
        })
	},[period, userId, loginInfo.userId])

    useEffect(() => {
        setPointOrPrice(currentValue * count)
    },[count,currentValue])

    function update(){
        getPVByDay(userId).then(r => {
            if(r.result){
                setRegistrationList(<Line data={createGraphData(r.data.list,r.data.list[0].stock_name)} />)
            } else {
                alert("取得失敗")
            }
        })
    }
    return(
    <div className="wrapper">
        <header className="App-header"></header>
        <Dialog title={dialogTitle} message={dialogMessage} show={show} handleClose={() => setShow(false)} />
        <Header />
        <Category />
        <Container>
            <Container className='d-none'>
                <h5><Icon.Magic /> スタイルを選んで生成</h5>
                <div className='d-flex justify-content-center' style={{gap:"6px 10px"}} >
                    <div className='style-selector' style={{position:"relative",border:"5px solid lightblue",borderRadius:"10px",borderTop:"none",width:"400px",height:"100px",marginTop:"100px"
                    }}>
                        <img style={{position:"absolute",bottom:"10px",left:"10px"}} width={160} src="/img/ourt_AI_Diffusion_XL_Anime_V2.webp" />
                        <div style={{position:"absolute",bottom:"10px",left:"180px"}}>
                            <b style={{fontSize:"24px"}}>アニメイラスト</b> <Chip label={<><Icon.GraphUpArrow /> <b>823</b></>} />
                            <p style={{color:"#555555"}}>
                                説明テキスト
                            </p>
                        </div>
                    </div>
                    <div className='style-selector' style={{position:"relative",border:"5px solid lightblue",borderRadius:"10px",borderTop:"none",width:"400px",height:"100px",marginTop:"100px"
                    }}>
                        <img style={{position:"absolute",bottom:"10px",left:"10px"}} width={160} src="/img/flux-schnell.webp" />
                        <div style={{position:"absolute",bottom:"10px",left:"180px"}}>
                            <b style={{fontSize:"24px"}}>写真</b> <Chip label={<><Icon.GraphUpArrow /> <b>123</b></>} />
                            <p style={{color:"#555555"}}>
                                説明テキスト
                            </p>
                        </div>
                    </div>
                    <div className='style-selector' style={{position:"relative",border:"5px solid lightblue",borderRadius:"10px",borderTop:"none",width:"400px",height:"100px",marginTop:"100px"
                    }}>
                        <img style={{position:"absolute",bottom:"10px",left:"10px"}} width={160} src="/img/ReproductionSDXL_2v12.webp" />
                        <div style={{position:"absolute",bottom:"10px",left:"180px"}}>
                            <b style={{fontSize:"24px"}}>切り絵</b> <Chip label={<><Icon.GraphUpArrow /> <b>334</b></>} />
                            <p style={{color:"#555555"}}>
                                説明テキスト
                            </p>
                        </div>
                    </div>
                </div>
            </Container>
            <hr className='mt-5' />
            <p style={{borderBottom:"3px solid #55AAFF",fontSize:"24px",fontWeight:"bold"}}>分析</p>
            
            {/* 日別推移分析 */}
            <Container className='m-3 p-3' style={{backgroundColor: '#e8f4fd', borderRadius: '10px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)'}}>
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h5><Icon.GraphUp /> 日別推移分析</h5>
                    <div className="d-flex align-items-center gap-2">
                        <span style={{fontSize: '14px', fontWeight: 'bold'}}>期間:</span>
                        <Form.Select 
                            size="sm" 
                            style={{width: '150px'}}
                            value={period}
                            onChange={(e) => handlePeriodChange(parseInt(e.target.value))}
                            disabled={loading}
                        >
                            <option value={7}>過去7日</option>
                            <option value={30}>過去30日</option>
                            <option value={90}>過去90日</option>
                            <option value={180}>過去180日</option>
                            <option value={365}>過去1年</option>
                        </Form.Select>
                        {loading && <div className="spinner-border spinner-border-sm text-primary" role="status"></div>}
                    </div>
                </div>
                <Row>
                    <Col md={6}>
                        <div className="mb-3">
                            <h6><Icon.Eye /> 日別閲覧数推移（{getPeriodLabel(period)}）</h6>
                            <div style={{height: '300px', backgroundColor: 'white', borderRadius: '8px', padding: '10px', position: 'relative'}}>
                                {loading && (
                                    <div className="d-flex justify-content-center align-items-center h-100">
                                        <div className="spinner-border text-primary" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                    </div>
                                )}
                                {!loading && registrationList}
                            </div>
                        </div>
                    </Col>
                    <Col md={6}>
                        <div className="mb-3">
                            <h6><Icon.Heart /> 日別いいね数推移（{getPeriodLabel(period)}）</h6>
                            <div style={{height: '300px', backgroundColor: 'white', borderRadius: '8px', padding: '10px', position: 'relative'}}>
                                {loading && (
                                    <div className="d-flex justify-content-center align-items-center h-100">
                                        <div className="spinner-border text-primary" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                    </div>
                                )}
                                {!loading && favoriteList}
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
            {analyzeData && (
                <Container className='m-3 p-3' style={{backgroundColor: '#f8f9fa', borderRadius: '10px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)'}}>
                    <h5><Icon.BarChart /> ユーザー詳細分析</h5>
                    <Row>
                        <Col md={6}>
                            <Table bordered hover>
                                <tbody>
                                    <tr><th style={{backgroundColor: '#55AAFF', color: 'white'}}>合計投稿数</th><td><strong>{analyzeData.total_post}</strong></td></tr>
                                    <tr><th style={{backgroundColor: '#55AAFF', color: 'white'}}>合計いいね数</th><td><strong>{analyzeData.total_favorite}</strong></td></tr>
                                    <tr><th style={{backgroundColor: '#55AAFF', color: 'white'}}>合計PV</th><td><strong>{analyzeData.total_pv}</strong></td></tr>
                                    <tr><th style={{backgroundColor: '#55AAFF', color: 'white'}}>平均いいね数（直近3ヶ月）</th><td><strong>{analyzeData.avg_favorite}</strong></td></tr>
                                </tbody>
                            </Table>
                        </Col>
                        <Col md={6}>
                            <Table bordered hover>
                                <tbody>
                                    <tr><th style={{backgroundColor: '#55AAFF', color: 'white'}}>平均PV（直近3ヶ月）</th><td><strong>{analyzeData.avg_pv}</strong></td></tr>
                                    <tr><th style={{backgroundColor: '#55AAFF', color: 'white'}}>フォロー数</th><td><strong>{analyzeData.follow_count}</strong></td></tr>
                                    <tr><th style={{backgroundColor: '#55AAFF', color: 'white'}}>フォロワー数</th><td><strong>{analyzeData.follower_count}</strong></td></tr>
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                    <Row className="mt-3">
                        <Col md={6}>
                            <h6><Icon.PieChart /> 投稿タイプ別集計</h6>
                            <ul className="list-group">
                                {analyzeData.post_type_count && analyzeData.post_type_count.map((row,i)=>(
                                    <li key={i} className="list-group-item d-flex justify-content-between align-items-center">
                                        {row.type === 'image' ? '📷 画像' : row.type === 'video' ? '🎬 動画' : row.type === 'text' ? '📝 テキスト' : row.type}
                                        <Badge bg="primary" pill>{row.count}</Badge>
                                    </li>
                                ))}
                            </ul>
                        </Col>
                        <Col md={6}>
                            <h6><Icon.GraphUp /> 投稿数推移（{getPeriodLabel(period)}）</h6>
                            <div style={{height: '300px'}}>
                                <Line 
                                    data={{
                                        labels: analyzeData.post_by_day.map(d=>d.ymd),
                                        datasets: [{
                                            label: '投稿数',
                                            data: analyzeData.post_by_day.map(d=>d.count),
                                            backgroundColor: 'rgba(85,170,255,0.3)',
                                            borderColor: '#55AAFF',
                                            fill: true,
                                        }]
                                    }}
                                    options={{
                                        responsive: true,
                                        maintainAspectRatio: false,
                                        plugins: {
                                            legend: {
                                                position: 'top',
                                            },
                                            title: {
                                                display: false,
                                            },
                                        },
                                    }}
                                />
                            </div>
                        </Col>
                    </Row>
                </Container>
            )}
            
            {/* AI利用状況分析 */}
            {analyzeData && analyzeData.ai_usage && (
                <Container className='m-3 p-3' style={{backgroundColor: '#fff3cd', borderRadius: '10px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)'}}>
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <h5><Icon.Robot /> AI利用状況分析</h5>
                        <div className="d-flex align-items-center gap-2">
                            <span style={{fontSize: '14px', fontWeight: 'bold'}}>期間:</span>
                            <Form.Select 
                                size="sm" 
                                style={{width: '150px'}}
                                value={period}
                                onChange={(e) => handlePeriodChange(parseInt(e.target.value))}
                                disabled={loading}
                            >
                                <option value={7}>過去7日</option>
                                <option value={30}>過去30日</option>
                                <option value={90}>過去90日</option>
                                <option value={180}>過去180日</option>
                                <option value={365}>過去1年</option>
                            </Form.Select>
                            {loading && <div className="spinner-border spinner-border-sm text-primary" role="status"></div>}
                        </div>
                    </div>
                    
                    <Row>
                        <Col md={4}>
                            <div className="mb-4">
                                <h6><Icon.Image /> AI画像生成状況</h6>
                                <Table bordered hover size="sm">
                                    <thead>
                                        <tr style={{backgroundColor: '#ffc107'}}><th>ステータス</th><th>回数</th></tr>
                                    </thead>
                                    <tbody>
                                        {analyzeData.ai_usage.ai_gen_status && analyzeData.ai_usage.ai_gen_status.map((row,i)=>(
                                            <tr key={i}>
                                                <td>
                                                    {row.status === '0' ? '⏳ 待機中' : 
                                                     row.status === '1' ? '⚙️ 処理中' : 
                                                     row.status === '2' ? '✅ 完了' : 
                                                     row.status === '3' ? '❌ エラー' : `ステータス${row.status}`}
                                                </td>
                                                <td><Badge bg="warning">{row.count}</Badge></td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </div>
                            
                            <div className="mb-4">
                                <h6><Icon.ChatDots /> AIチャット状況</h6>
                                <Table bordered hover size="sm">
                                    <thead>
                                        <tr style={{backgroundColor: '#17a2b8'}}><th>役割</th><th>回数</th></tr>
                                    </thead>
                                    <tbody>
                                        {analyzeData.ai_usage.ai_chat_role && analyzeData.ai_usage.ai_chat_role.map((row,i)=>(
                                            <tr key={i}>
                                                <td>{row.role === 'user' ? '👤 ユーザー' : row.role === 'assistant' ? '🤖 アシスタント' : row.role}</td>
                                                <td><Badge bg="info">{row.count}</Badge></td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </div>
                            
                            <div className="mb-4">
                                <h6><Icon.CameraVideo /> 動画生成状況</h6>
                                <Table bordered hover size="sm">
                                    <thead>
                                        <tr style={{backgroundColor: '#28a745'}}><th>ステータス</th><th>回数</th></tr>
                                    </thead>
                                    <tbody>
                                        {analyzeData.ai_usage.video_gen_status && analyzeData.ai_usage.video_gen_status.map((row,i)=>(
                                            <tr key={i}>
                                                <td>
                                                    {row.status === '0' ? '⏳ 待機中' : 
                                                     row.status === '1' ? '⚙️ 処理中' : 
                                                     row.status === '2' ? '✅ 完了' : 
                                                     row.status === '3' ? '❌ エラー' : `ステータス${row.status}`}
                                                </td>
                                                <td><Badge bg="success">{row.count}</Badge></td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </div>
                        </Col>
                        
                        <Col md={8}>
                            <Row>
                                <Col md={12} className="mb-3">
                                    <h6>📊 AI画像生成推移（{getPeriodLabel(period)}）</h6>
                                    <div style={{height: '200px'}}>
                                        <Line 
                                            data={{
                                                labels: analyzeData.ai_usage.ai_gen_by_day?.map(d=>d.ymd) || [],
                                                datasets: [{
                                                    label: 'AI画像生成回数',
                                                    data: analyzeData.ai_usage.ai_gen_by_day?.map(d=>d.count) || [],
                                                    backgroundColor: 'rgba(255,99,132,0.3)',
                                                    borderColor: '#FF6384',
                                                    fill: true,
                                                }]
                                            }}
                                            options={{
                                                responsive: true,
                                                maintainAspectRatio: false,
                                                plugins: { legend: { position: 'top' } }
                                            }}
                                        />
                                    </div>
                                </Col>
                                
                                <Col md={6} className="mb-3">
                                    <h6>💬 AIチャット推移</h6>
                                    <div style={{height: '200px'}}>
                                        <Line 
                                            data={{
                                                labels: analyzeData.ai_usage.ai_chat_by_day?.map(d=>d.ymd) || [],
                                                datasets: [{
                                                    label: 'AIチャット回数',
                                                    data: analyzeData.ai_usage.ai_chat_by_day?.map(d=>d.count) || [],
                                                    backgroundColor: 'rgba(54,162,235,0.3)',
                                                    borderColor: '#36A2EB',
                                                    fill: true,
                                                }]
                                            }}
                                            options={{
                                                responsive: true,
                                                maintainAspectRatio: false,
                                                plugins: { legend: { position: 'top' } }
                                            }}
                                        />
                                    </div>
                                </Col>
                                
                                <Col md={6} className="mb-3">
                                    <h6>🎬 動画生成推移</h6>
                                    <div style={{height: '200px'}}>
                                        <Line 
                                            data={{
                                                labels: analyzeData.ai_usage.video_gen_by_day?.map(d=>d.ymd) || [],
                                                datasets: [{
                                                    label: '動画生成回数',
                                                    data: analyzeData.ai_usage.video_gen_by_day?.map(d=>d.count) || [],
                                                    backgroundColor: 'rgba(255,206,86,0.3)',
                                                    borderColor: '#FFCE56',
                                                    fill: true,
                                                }]
                                            }}
                                            options={{
                                                responsive: true,
                                                maintainAspectRatio: false,
                                                plugins: { legend: { position: 'top' } }
                                            }}
                                        />
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Container>
            )}
            
            {/* 時間帯別・曜日別分析 */}
            {analyzeData && analyzeData.hour_analysis && (
                <Container className='m-3 p-3' style={{backgroundColor: '#d1ecf1', borderRadius: '10px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)'}}>
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <h5><Icon.Clock /> 時間帯別・曜日別分析</h5>
                        <div className="d-flex align-items-center gap-2">
                            <span style={{fontSize: '14px', fontWeight: 'bold'}}>期間:</span>
                            <Form.Select 
                                size="sm" 
                                style={{width: '150px'}}
                                value={period}
                                onChange={(e) => handlePeriodChange(parseInt(e.target.value))}
                                disabled={loading}
                            >
                                <option value={7}>過去7日</option>
                                <option value={30}>過去30日</option>
                                <option value={90}>過去90日</option>
                                <option value={180}>過去180日</option>
                                <option value={365}>過去1年</option>
                            </Form.Select>
                            {loading && <div className="spinner-border spinner-border-sm text-primary" role="status"></div>}
                        </div>
                    </div>
                    
                    <Row className="mb-4">
                        <Col md={12}>
                            <h6>⏰ 時間帯別活動パターン（{getPeriodLabel(period)}）</h6>
                        </Col>
                        <Col md={4}>
                            <div style={{height: '300px'}}>
                                <Bar 
                                    data={{
                                        labels: Array.from({length: 24}, (_, i) => `${i}時`),
                                        datasets: [{
                                            label: '投稿数',
                                            data: Array.from({length: 24}, (_, i) => {
                                                const found = analyzeData.hour_analysis.post_by_hour?.find(d => parseInt(d.hour) === i);
                                                return found ? found.count : 0;
                                            }),
                                            backgroundColor: 'rgba(85,170,255,0.7)',
                                            borderColor: '#55AAFF',
                                        }]
                                    }}
                                    options={{
                                        responsive: true,
                                        maintainAspectRatio: false,
                                        plugins: { 
                                            legend: { position: 'top' },
                                            title: { display: true, text: '📝 投稿時間分布' }
                                        }
                                    }}
                                />
                            </div>
                        </Col>
                        <Col md={4}>
                            <div style={{height: '300px'}}>
                                <Bar 
                                    data={{
                                        labels: Array.from({length: 24}, (_, i) => `${i}時`),
                                        datasets: [{
                                            label: 'AI画像生成回数',
                                            data: Array.from({length: 24}, (_, i) => {
                                                const found = analyzeData.hour_analysis.ai_gen_by_hour?.find(d => parseInt(d.hour) === i);
                                                return found ? found.count : 0;
                                            }),
                                            backgroundColor: 'rgba(255,99,132,0.7)',
                                            borderColor: '#FF6384',
                                        }]
                                    }}
                                    options={{
                                        responsive: true,
                                        maintainAspectRatio: false,
                                        plugins: { 
                                            legend: { position: 'top' },
                                            title: { display: true, text: '🎨 AI生成時間分布' }
                                        }
                                    }}
                                />
                            </div>
                        </Col>
                        <Col md={4}>
                            <div style={{height: '300px'}}>
                                <Bar 
                                    data={{
                                        labels: Array.from({length: 24}, (_, i) => `${i}時`),
                                        datasets: [{
                                            label: 'AIチャット回数',
                                            data: Array.from({length: 24}, (_, i) => {
                                                const found = analyzeData.hour_analysis.ai_chat_by_hour?.find(d => parseInt(d.hour) === i);
                                                return found ? found.count : 0;
                                            }),
                                            backgroundColor: 'rgba(54,162,235,0.7)',
                                            borderColor: '#36A2EB',
                                        }]
                                    }}
                                    options={{
                                        responsive: true,
                                        maintainAspectRatio: false,
                                        plugins: { 
                                            legend: { position: 'top' },
                                            title: { display: true, text: '💬 チャット時間分布' }
                                        }
                                    }}
                                />
                            </div>
                        </Col>
                    </Row>
                    
                    <Row>
                        <Col md={12}>
                            <h6>📅 曜日別活動パターン（{getPeriodLabel(period)}）</h6>
                        </Col>
                        <Col md={4}>
                            <div style={{height: '300px'}}>
                                <Bar 
                                    data={{
                                        labels: ['日', '月', '火', '水', '木', '金', '土'],
                                        datasets: [{
                                            label: '投稿数',
                                            data: Array.from({length: 7}, (_, i) => {
                                                const found = analyzeData.day_of_week_analysis.post_by_day_of_week?.find(d => parseInt(d.day_of_week) === i + 1);
                                                return found ? found.count : 0;
                                            }),
                                            backgroundColor: 'rgba(85,170,255,0.7)',
                                            borderColor: '#55AAFF',
                                        }]
                                    }}
                                    options={{
                                        responsive: true,
                                        maintainAspectRatio: false,
                                        plugins: { 
                                            legend: { position: 'top' },
                                            title: { display: true, text: '📝 曜日別投稿数' }
                                        }
                                    }}
                                />
                            </div>
                        </Col>
                        <Col md={4}>
                            <div style={{height: '300px'}}>
                                <Bar 
                                    data={{
                                        labels: ['日', '月', '火', '水', '木', '金', '土'],
                                        datasets: [{
                                            label: 'AI画像生成回数',
                                            data: Array.from({length: 7}, (_, i) => {
                                                const found = analyzeData.day_of_week_analysis.ai_gen_by_day_of_week?.find(d => parseInt(d.day_of_week) === i + 1);
                                                return found ? found.count : 0;
                                            }),
                                            backgroundColor: 'rgba(255,99,132,0.7)',
                                            borderColor: '#FF6384',
                                        }]
                                    }}
                                    options={{
                                        responsive: true,
                                        maintainAspectRatio: false,
                                        plugins: { 
                                            legend: { position: 'top' },
                                            title: { display: true, text: '🎨 曜日別AI生成数' }
                                        }
                                    }}
                                />
                            </div>
                        </Col>
                        <Col md={4}>
                            <div style={{height: '300px'}}>
                                <Bar 
                                    data={{
                                        labels: ['日', '月', '火', '水', '木', '金', '土'],
                                        datasets: [{
                                            label: 'AIチャット回数',
                                            data: Array.from({length: 7}, (_, i) => {
                                                const found = analyzeData.day_of_week_analysis.ai_chat_by_day_of_week?.find(d => parseInt(d.day_of_week) === i + 1);
                                                return found ? found.count : 0;
                                            }),
                                            backgroundColor: 'rgba(54,162,235,0.7)',
                                            borderColor: '#36A2EB',
                                        }]
                                    }}
                                    options={{
                                        responsive: true,
                                        maintainAspectRatio: false,
                                        plugins: { 
                                            legend: { position: 'top' },
                                            title: { display: true, text: '💬 曜日別チャット数' }
                                        }
                                    }}
                                />
                            </div>
                        </Col>
                    </Row>
                </Container>
            )}
        </Container>
        <Footer />
    </div>
    )
}

export default Analyze;
